import { Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import Loader from "../components/Loader";
import {
  useRenewGymSubscriptionMutation,
  useUpdateGymMutation,
} from "../slices/gymSlice";

const RenewGymSubscriptionScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const location = useLocation();
  const { gymDetails } = location.state || {};
  const [paidAmount, setPaidAmount] = useState();
  const [subsAmount, setSubsAmount] = useState();
  const [notes, setNotes] = useState();
  const [subsType, setSubsType] = useState();
  const [subsCycle, setSubsCycle] = useState("Yearly");
  const [transactionId, setTransactionId] = useState();
  const [paymentFor, setPaymentFor] = useState("Software Fees");
  const [expiryDate, setExpiryDate] = useState(
    gymDetails?.subsExpiryDate?.split("T")[0] || ""
  );
  const [renewedDate, setRenewedDate] = useState(
    gymDetails?.subsExpiryDate?.split("T")[0] || ""
  );
  const [expirySubsType, setExpirySubsType] = useState(
    gymDetails?.subscriptionType || "Select Subscription Type"
  );

  const availableSubsTypes = [
    "Select Subscription Type",
    "Premium",
    "Not Paid",
    "Old Basic",
    "Old Premium",
    "Free",
  ];

  const subscriptionCycle = ["Yearly", "Monthly", "One Time"];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [renewSubscription, { isLoading }] = useRenewGymSubscriptionMutation();
  const [updateExpiryDate, { isUpdateGymLoading }] = useUpdateGymMutation();

  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      !paidAmount ||
      Number(paidAmount) <= 0 ||
      Number(paidAmount) > Number(subsAmount)
    ) {
      toast.warning("Please provide valid paid amount");
      return;
    }
    if (!subsAmount || Number(subsAmount) <= 0) {
      toast.warning("Please provide valid subscription amount");
      return;
    }
    if (!subsType || subsType === "Select Subscription Type") {
      toast.warning("Please select subscription type");
      return;
    }
    if (!renewedDate) {
      toast.warning("Please select renewed date");
      return;
    } else
      try {
        const payload = {
          _id: gymDetails?._id,
          paidAmount: paidAmount,
          subsAmount: subsAmount,
          subscriptionType: subsType,
          transactionId: transactionId,
          paymentFor: paymentFor,
          paymentCycle: subsCycle?.trim(),
          subsRenewedDate: renewedDate,
        };
        console.log("notes", notes);

        if (notes?.length > 10) payload.notes = notes;
        console.log(payload);
        const res = await renewSubscription({
          payload: payload,
          token: userInfo?.token,
        }).unwrap();
        if (res) toast.success("Gym Subscription Renewed Successfully");
        // navigate(redirect);
        navigate("/allGyms");
      } catch (err) {
        toast.error(err?.data?.error || err.error);
      }
  };

  const handleExpiryDateUpdate = async (e) => {
    e.preventDefault();
    if (!expiryDate) {
      toast.warning("Please select expiry date");
      return;
    }
    if (!expirySubsType || expirySubsType === "Select Subscription Type") {
      toast.warning("Please select subscription type");
      return;
    } else
      try {
        const res = await updateExpiryDate({
          payload: {
            subsExpiryDate: expiryDate,
            subscriptionType: expirySubsType,
          },
          gymId: gymDetails?._id,
          token: userInfo?.token,
        }).unwrap();
        if (res) toast.success("Gym Expiry date updated Successfully");
        // navigate(redirect);
        navigate("/allGyms");
      } catch (err) {
        toast.error(err?.data?.error || err.error);
      }
  };
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "90vh",
      }}
    >
      <Row>
        <Col md="6">
          <h6 style={{ color: "green" }}>Renew Gym Subscription</h6>
          <Form.Group className="my-2" controlId="gymId">
            <Form.Control
              type="text"
              pattern="[0-9]*" // Allow only digits
              value={gymDetails?._id || ""}
              disabled={true}
            />
          </Form.Group>
          <Form.Group className="my-2" controlId="gymName">
            <Form.Control
              type="text"
              value={gymDetails?.name || ""}
              disabled={true}
            />
          </Form.Group>

          <Form.Group as={Row} className="my-2" controlId="gymType">
            <Form.Label>
              Subscription Type <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="12">
              <Form.Select
                value={subsType}
                onChange={(e) => setSubsType(e.target.value)}
                placeholder="Select Subscription Type"
              >
                {availableSubsTypes.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="my-2" controlId="gymType">
            <Form.Label>
              Subscription Cycle <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="12">
              <Form.Select
                value={subsCycle}
                onChange={(e) => setSubsCycle(e.target.value)}
                placeholder="Select Subscription Cycle"
              >
                {subscriptionCycle.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="renewedDate">
            <Form.Label>
              Renewed Date <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="12">
              <Form.Control
                type="date"
                value={renewedDate}
                onChange={(e) => setRenewedDate(e.target.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group className="my-2" controlId="subsAmount">
            <div style={{ display: "flex" }}>
              <InputGroup>
                {" "}
                <Form.Control
                  type="text"
                  placeholder="Subscription Amount"
                  value={subsAmount}
                  onChange={(e) => setSubsAmount(e.target.value)}
                />
              </InputGroup>
            </div>
          </Form.Group>
          <Form.Group className="my-2" controlId="subsAmount">
            <div style={{ display: "flex" }}>
              <InputGroup>
                {" "}
                <Form.Control
                  type="text"
                  placeholder="enter Notes to remember"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </InputGroup>
            </div>
          </Form.Group>
          <Form.Group className="my-2" controlId="paidAmount">
            <div style={{ display: "flex" }}>
              <InputGroup>
                {" "}
                <Form.Control
                  type="text"
                  placeholder="Paid Amount"
                  value={paidAmount}
                  onChange={(e) => setPaidAmount(e.target.value)}
                />
              </InputGroup>
            </div>
          </Form.Group>
          <Form.Group className="my-2" controlId="transactionId">
            <div style={{ display: "flex" }}>
              <InputGroup>
                {" "}
                <Form.Control
                  type="text"
                  placeholder="Transaction ID"
                  value={transactionId}
                  onChange={(e) => setTransactionId(e.target.value)}
                />
              </InputGroup>
            </div>
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            style={{ marginTop: "1rem", background: "green" }}
            onClick={submitHandler}
          >
            Submit
          </Button>
          {isLoading && <Loader />}
        </Col>

        <Col md="6" style={{ borderLeft: "0.5px solid grey" }}>
          <h6 style={{ color: "green" }}>Update Expiry Date</h6>
          <Form.Group className="my-2" controlId="gymId">
            <Form.Label id="username" column="true" md="4">
              Gym Id :{" "}
            </Form.Label>
            <Form.Control
              type="text"
              pattern="[0-9]*" // Allow only digits
              value={gymDetails?._id || ""}
              disabled={true}
            />
          </Form.Group>
          <Form.Group className="my-2" controlId="gymName">
            <Form.Label id="gymName">Gym Name : </Form.Label>
            <Form.Control
              type="text"
              value={gymDetails?.name || ""}
              disabled={true}
            />
          </Form.Group>

          <Form.Group as={Row} className="my-2" controlId="expiryDate">
            <Form.Label column="true" sm="4">
              Expiry Date <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="date"
                value={expiryDate}
                onChange={(e) => setExpiryDate(e.target.value)}
                placeholder="in format 'YYYY-MM-DD'"
              ></Form.Control>
            </Col>
          </Form.Group>
          <Form.Group
            as={Row}
            className="my-2"
            controlId="expirySubscriptionType"
          >
            <Form.Label column="true" sm="4">
              Subscription Type <label style={{ color: "red" }}>*</label> :
            </Form.Label>

            <Col sm="6">
              <Form.Select
                value={expirySubsType}
                onChange={(e) => setExpirySubsType(e.target.value)}
              >
                {availableSubsTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Form.Group>
          <Button
            type="submit"
            variant="primary"
            style={{ marginTop: "1rem", background: "green" }}
            onClick={handleExpiryDateUpdate}
          >
            Submit
          </Button>
          {isLoading && <Loader />}
        </Col>
      </Row>
    </div>
  );
};

export default RenewGymSubscriptionScreen;
